export const GET_ENTITY_REQUEST = '[ENTITY] GET_ENTITY_REQUEST'
export const GET_ENTITY_SUCCESS = '[ENTITY] GET_ENTITY_SUCCESS'
export const GET_ENTITY_FAILED = '[ENTITY] GET_ENTITY_FAILED'

export const GET_ENTITY_LIST_REQUEST = '[ENTITY] GET_ENTITY_LIST_REQUEST'
export const GET_ENTITY_LIST_SUCCESS = '[ENTITY] GET_ENTITY_LIST_SUCCESS'
export const GET_ENTITY_LIST_FAILED = '[ENTITY] GET_ENTITY_LIST_FAILED'

export const CREATE_ENTITY_REQUEST = '[ENTITY] CREATE_ENTITY_REQUEST'
export const CREATE_ENTITY_SUCCESS = '[ENTITY] CREATE_ENTITY_SUCCESS'
export const CREATE_ENTITY_FAILED = '[ENTITY] CREATE_ENTITY_FAILED'

export const EDIT_ENTITY_REQUEST = '[ENTITY] EDIT_ENTITY_REQUEST'
export const EDIT_ENTITY_SUCCESS = '[ENTITY] EDIT_ENTITY_SUCCESS'
export const EDIT_ENTITY_FAILED = '[ENTITY] EDIT_ENTITY_FAILED'

export const DELETE_ENTITY_REQUEST = '[ENTITY] DELETE_ENTITY_REQUEST'
export const DELETE_ENTITY_SUCCESS = '[ENTITY] DELETE_ENTITY_SUCCESS'
export const DELETE_ENTITY_FAILED = '[ENTITY] DELETE_ENTITY_FAILED'

export const RESET_ENTITIES_FORM = '[ENTITY] RESET_ENTITIES_FORM';

export const ENTITY_SEARCH_REQUEST = '[ENTITY] ENTITY_SEARCH_REQUEST'
export const ENTITY_SEARCH_SUCCESS = '[ENTITY] ENTITY_SEARCH_SUCCESS'
export const ENTITY_SEARCH_FAILED = '[ENTITY] ENTITY_SEARCH_FAILED'